<template>
  <div class="RequestManagementSearchPanel">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row>
          <v-col>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <label for="sectionType">{{ $t("sectionType") }}: </label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="sectionType"
                          :items="sectionTypes"
                          :label="$t('sectionType')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changeSectionType"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label for="requestType">{{ $t("requestType") }}:</label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="requestType"
                          :items="requestTypes"
                          :label="$t('requestType')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changeRequestType"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
        </v-card-actions>
      </div>
    </box>
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import PageKind from "../../model/PageKind";
import AccessToType from "../../model/AccessToType";
export default {
  props: {},
  data() {
    return {
      //accessTo: 1,
      requestTypes: [],
      requestType: "",

      sectionType: "",
      sectionTypes: [],
    };
  },
  mounted() {
    this.getRequestTypes();
  },

  methods: {
    getRequestTypes() {
      this.requestTypes = [];

      let permissionList = this.$store.state.permission.permissionList;
      if (permissionList.includes(105)) {
        this.requestTypes.push(
          PageKind.RequestTypeArray().find((el) => {
            return el["Code"] === "1";
          })
        );
      }
      if (permissionList.includes(107)) {
        this.requestTypes.push(
          PageKind.RequestTypeArray().find((el) => {
            return el["Code"] === "2";
          })
        );
      }
      if (permissionList.includes(109)) {
        this.requestTypes.push(
          PageKind.RequestTypeArray().find((el) => {
            return el["Code"] === "3";
          })
        );
      }
      if (permissionList.includes(110)) {
        this.requestTypes.push(
          PageKind.RequestTypeArray().find((el) => {
            return el["Code"] === "4";
          })
        );
      }
      if (permissionList.includes(163)) {
        this.requestTypes.push(
          PageKind.RequestTypeArray().find((el) => {
            return el["Code"] === "5";
          })
        );
      }

      if (this.requestTypes.length > 0) {
        this.requestType = this.requestTypes[0];
      }

      this.getSectionTypes();
    },
    getSectionTypes() {
      if (!this.requestType.Code) {
        return;
      }

      //this.sectionTypes.push({ Name: this.$t("allSection"), Code: -1 });
      //this.sectionType = this.sectionTypes[0];

      var accessTo = "-1";
      switch (this.requestType.Code.toString()) {
        case "1":
          accessTo = AccessToType.Vacation;
          break;
        case "2":
          accessTo = AccessToType.Mission;
          break;
        case "3":
          accessTo = AccessToType.IO;
          break;
        case "4":
          accessTo = AccessToType.ExtraWork;
          break;
        case "5":
          accessTo = AccessToType.SpecificExtraWork;
          break;
      }

      var params = new URLSearchParams();
      params.append("accessTo", accessTo);

      this.$store.dispatch("sections/GetSectionsList", { params }).then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          this.search();
        }
      });
    },
    changeRequestType() {
      this.getSectionTypes();
      //this.search();
    },
    changeSectionType() {
      this.search();
    },
    search() {
      var searchParams = {
        pagekind: this.requestType.Code,
        sectionCode: this.sectionType?.Code?.toString().trim() || "-1",
      };

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
}

::v-deep .management-checkbox .v-label {
  font-size: 0.9rem;
  text-align: right;
}
</style>